import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=d961e3a2&scoped=true&"
import script from "./infoForm.vue?vue&type=script&lang=js&"
export * from "./infoForm.vue?vue&type=script&lang=js&"
import style0 from "./infoForm.vue?vue&type=style&index=0&id=d961e3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d961e3a2",
  null
  
)

export default component.exports